import { lazy } from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

const 
      GaleriaAdmin = lazy(() => import('../../../views/GaleriaAdmin'))


const Index = (props: any) =>{
  return (
    <Switch>
      <Route path={`${props.match.path}/admin`} component={GaleriaAdmin} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
